export default {"src":"/_next/static/media/pinterest.759c43ae.svg","height":15,"width":15,"blurWidth":0,"blurHeight":0};